import QueryHistoryContent from '../components/query/QueryHistoryContent';

const QueryHistory = () => <QueryHistoryContent showTitle={true} />;

export default QueryHistory;
